import React from "react"
import { Grid, Container, Header, Label } from "semantic-ui-react"
import { NavLink, withRouter } from "react-router-dom"

const TabNavTopNavigation = withRouter(({ location, sections }) => (
  <Grid.Row columns="equal" className="TabNav__TopNavigation">
    {sections.map((section, index) => {
      return (
        <Grid.Column
          key={index}
          className={`TabNav__TopNavigationCell ${
            section.disabled ? `disabled` : ``
          }`}
        >
          <NavLink
            data-testid={`${section.name}NavLink`}
            to={section.disabled ? `/` : `/${section.name}`}
            isActive={(_, location) =>
              location.pathname.startsWith(`/${section.name}`)
            }
          >
            {section.cornerLabel ? (
              <Label
                corner="right"
                {...section.cornerLabel}
                color={
                  section.cornerLabel.color === "transparent"
                    ? null
                    : section.cornerLabel.color
                }
                className={
                  section.cornerLabel.color === "transparent"
                    ? "TopNavCornerLabel__Transparent"
                    : ""
                }
              />
            ) : null}
            <Container
              className="TabNav__TopNavigationLinkContainer"
              textAlign="center"
            >
              <section.icon className="TabNav__TopNavigationImage" />
              <Header as="h5" className="TabNav__TopNavigationHeader">
                {section.title}
              </Header>
            </Container>
          </NavLink>
        </Grid.Column>
      )
    })}
  </Grid.Row>
))

export default TabNavTopNavigation
